import { createElement as rc } from 'react';
import * as reactMenu from '@szhsin/react-menu';

export default props => {
     
    const { children, disabled, onClick, ...otherProps } = props;
    return rc(
        reactMenu.MenuItem,
        { onClick, disabled, role: 'menuitem', 'aria-label': otherProps['aria-label'] },
        children
    );
};
